<template>
    <div class="module">
        <b-row class="skeleton">
            <b-col md="12" class="content">
                <div
                    v-for="index in rowCount"
                    :key="index"
                    :class="{
                        'm-0': index === rowCount,
                        smaller: index % 2 === 0
                    }"
                ></div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        rowCount: {
            type: Number,
            default: 1
        }
    }
};
</script>
